import React, { useEffect, useMemo, useRef, useState } from "react";
import SkyLayout from "./SkyLayout";
import { isEmpty } from "lodash";
import jwt_decode from "jwt-decode";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import SingleEvent from "./SingleEvent";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
const InPlay = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("in_play");
  const [activeFav, setActiveFav] = useState([]);
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({});
  const scoreAll = useContextSelector(AuthContext, (ctx) => {
    return ctx.scoreAll;
  });
  const setSearch = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSearch;
  });
  const isSportTab = useMemo(() => activeTab, [activeTab]);
  const tabs = [
    { key: "in_play", label: "In-Play" },
    { key: "today", label: "Today" },
    { key: "tomorrow", label: "Tomorrow" },
    { key: "result", label: "Result" },
  ];
  const isFirstRun = useRef(true);
  const handleClick = (tab) => {
    setActiveTab(tab);
  };
  const getData = async () => {
    setLoader(true);
    let { status, data } = await apiGet(apiPath.seriesList, {
      gameType: "all",
      type: isSportTab,
      userId: !isEmpty(localStorage.getItem("token"))
        ? jwt_decode(localStorage.getItem("token"))?.user?._id
        : "",
    });

    if (data?.success) {
      let newResult = data?.results
        ?.map((res) => {
          return res?.matchList;
        })
        .flat();
      let updated = newResult.sort(
        (a, b) => new Date(a.eventDateTime) - new Date(b.eventDateTime)
      );
      setData({
        cricket: updated?.filter((res) => {
          return res?.gameType == "cricket";
        }),
        soccer: updated?.filter((res) => {
          return res?.gameType == "soccer";
        }),
        tennis: updated?.filter((res) => {
          return res?.gameType == "tennis";
        }),
      });
      setActiveFav(
        newResult
          ?.filter((res) => {
            return res?.isFavourite;
          })
          ?.map((res) => {
            return res?.eventId;
          })
      );
    }
    setLoader(false);
  };
  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return; // skip initial run if needed
    }

    if (isSportTab != "myfav") {
      getData();
    }
  }, [isSportTab]);
  const addToFavioute = async (
    id,
    favoriteType,
    favoriteMarketId,
    eventType
  ) => {
    const { status, data: response_users } = await apiGet(
      apiPath.addToFavourite +
        `?eventId=${id}&favoriteType=${favoriteType}&favoriteMarketId=${favoriteMarketId}&eventType=${eventType}`
    );

    if (response_users?.success) {
      if (activeFav?.includes(id)) {
        setActiveFav((prev) => {
          return prev.filter((item) => {
            return item !== id;
          });
        });
      } else {
        setActiveFav((prev) => {
          return [...prev, id];
        });
      }
    }
  };
  const Render = ({ list, title }) => {
    return (
      <div id="inPlayEventType_4" style={{ display: "block" }}>
        <h3>{title}</h3>
        <ul className="highlight-list" id="inPlayList_4">
          {list?.map((res) => {
            return (
              <SingleEvent
                addToFavioute={addToFavioute}
                item={res}
                animate={activeFav?.includes(res?.eventId)}
                scoreAll={scoreAll}
              />
            );
          })}
        </ul>
      </div>
    );
  };
  return (
    <SkyLayout>
      <div className="mian-wrap">
        <div className="tab-wrap">
          <ul>
            {tabs.map((tab) => (
              <li
                key={tab.key}
                id={tab.key}
                className={activeTab === tab.key ? "select" : ""}
              >
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault(); // stop navigation
                    if (tab?.key == "result") {
                      navigate("/result-sky");
                    } else {
                      handleClick(tab.key);
                    }
                  }}
                  neua={tab.label}
                >
                  {tab.label}
                </a>
              </li>
            ))}
          </ul>
          <div onClick={() => setSearch(true)} className="a-search">
            Search
          </div>
        </div>
        <div className="wrap-highlight_list" id="inPlayData">
          {data?.cricket?.length > 0 && (
            <Render title={"Cricket"} list={data?.cricket} />
          )}
          {data?.soccer?.length > 0 && (
            <Render title={"Soccer"} list={data?.soccer} />
          )}
          {data?.tennis?.length > 0 && (
            <Render title={"Tennis"} list={data?.tennis} />
          )}

          <div id="inplayVirtualCricketImage" className="footer-kv" style={{}}>
            <a
              id="inplayVirtualCricketEntrance"
              className="entrance"
              href="javascript:CommonTransferWalletHandler.openDepositPage('1', 'BetRadar', 'SPORTRADAR', '', 'SPORTRADAR_VIRTUAL_001', '', true)"
              style={{ cursor: "pointer" }}
              neua="BetRadar Banner"
            >
              <img
                src={require("../../assets/images/kv-virtual-cricket-m.jpg")}
                style={{ width: "100%" }}
                alt
                draggable="false"
              />
            </a>
          </div>
        </div>
      </div>{" "}
    </SkyLayout>
  );
};

export default InPlay;
